<div class="border border-neutral-2 rounded min-h-28 max-h-40 overflow-y-scroll">
  @if (availableLayouts) {
    <div class="grid grid-cols-w-24 gap-2 p-2">
      @for (layout of availableLayouts; track layout) {
        <div class="aspect-square relative group cursor-pointer max-w-24" (click)="selectLayout(layout)">
          <div class="w-full h-full grid bg-neutral-4 rounded p-1.5 gap-1.5" [style.grid-template-areas]="layout">
            <div class="bg-white flex justify-center items-center" [style.grid-area]="'a'">1</div>
            @if (totalPhotosSelected > 1) {
              <div class="bg-white flex justify-center items-center" [style.grid-area]="'b'">2</div>
            }
            @if (totalPhotosSelected > 2) {
              <div class="bg-white flex justify-center items-center" [style.grid-area]="'c'">3</div>
            }
            @if (totalPhotosSelected > 3) {
              <div class="bg-white flex justify-center items-center" [style.grid-area]="'d'">4</div>
            }
            @if (totalPhotosSelected > 4) {
              <div class="bg-white flex justify-center items-center" [style.grid-area]="'e'">5</div>
            }
          </div>
          <div class="absolute bottom-1 left-1 w-5 h-5 rounded-full border border-neutral-2 flex justify-center items-center"
            [ngClass]="layout === selectedLayout ? 'bg-primary border-primary' : 'bg-white group-hover:bg-neutral-4'">
            <div class="rounded-full bg-white h-1.5 w-1.5"></div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="text-neutral-1 h-28 text-center grid place-items-center">Geen layouts beschikbaar <br> Selecteer minimaal 1 en maximaal 5 foto's</div>
  }
</div>
